var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-mask",class:{ 'animate-fade': _vm.visible, 'leaving': _vm.isLeaving },style:({ visibility: _vm.visible ? 'visible' : 'hidden' })},[_c('div',{staticClass:"loading-content"})])
}
var staticRenderFns = []

export { render, staticRenderFns }